import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import and from 'ember-truth-helpers/helpers/and';
import notEq from 'ember-truth-helpers/helpers/not-eq';
import or from 'ember-truth-helpers/helpers/or';
import BvMethodoIcon from 'volta/components/bv-methodo-icon';
import BaseCell from 'volta/components/cell/base-cell';
import isPresent from 'volta/helpers/is-present';
import type { TOC } from '@ember/component/template-only';
import type { CellBaseCellSignature } from 'volta/components/cell/base-cell';
const CellBufferIconCellComponent: TOC<CellBaseCellSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='buffer-icon-cell'
    as |baseCell|
  >
    {{#if
      (or
        (and (isPresent baseCell.value.methodology) (notEq baseCell.value.methodology 'NONE'))
        baseCell.value.isProtected
      )
    }}
      <BvMethodoIcon
        @methodology={{baseCell.value.methodology}}
        @isProtected={{baseCell.value.isProtected}}
        @reorderStrategy={{baseCell.value.reorderStrategy}}
      />
    {{/if}}
  </BaseCell>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default CellBufferIconCellComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'Cell::BufferIconCell': typeof CellBufferIconCellComponent;
        'cell/buffer-icon-cell': typeof CellBufferIconCellComponent;
    }
}
